import moment from "moment";
import {
  REQUEST_SENSOR,
  RECEIVE_SENSOR,
  FAILED_SENSOR,
  SAVE_SENSOR,
  SAVE_SENSOR_COMPLETE,
  SAVE_SENSOR_FAILED,
  HOVER_CHART,
  HOVER_DATE,
  BRUSH_DOMAIN,
  TOGGLE_PIN,
  UPDATE_LATITUDE,
  UPDATE_LONGITUDE,
  UPDATE_FIELD_CAPACITY,
  UPDATE_REFILL_POINT,
  UPDATE_NAME,
  UPDATE_SOIL_TYPE,
  UPDATE_DEPTH_VISIBILITY,
  UPDATE_WARNING_PERCENTAGE,
  UPDATE_TURNED_OFF,
  UPDATE_SCALE,
  UPDATE_SHOW_PRECIPITATION,
  UPDATE_SHOW_TEMPERATURE,
  UPDATE_END_DATE,
  UPDATE_START_DATE,
  TOGGLE_VISIBLE_DEPTHS,
} from "./../actions/sensorActions";

export function sensorUpdates(
  state = {
    // Special fields from here, we keep them 0, only to update them in the model if they have changed
    // To improve this, we should get rid of the sensorModel alltogether.
    updatedLatitude: null,
    updatedLongitude: null,
    updatedName: null,
    updatedSoilType: null,
    updatedFieldCapacity: null,
    updatedRefillPoint: null,
    updatedDepthVisibility: null,
    updatedWarningPercentage: null,
    updatedTurnedOff: null,
    updatedScale: null,
    updatedShowTemperature: null,
    updatedShowPrecipitation: null,
    updatedStartDate: null,
    updatedEndDate: null,
  },
  action
) {
  switch (action.type) {
    case UPDATE_END_DATE:
      return Object.assign({}, state, {
        updatedEndDate: action.date,
      });
    case UPDATE_START_DATE:
      return Object.assign({}, state, {
        updatedStartDate: action.date,
      });
    case UPDATE_SHOW_PRECIPITATION:
      return Object.assign({}, state, {
        updatedShowPrecipitation: action.checked,
      });
    case UPDATE_SHOW_TEMPERATURE:
      return Object.assign({}, state, {
        updatedShowTemperature: action.checked,
      });
    case UPDATE_TURNED_OFF:
      return Object.assign({}, state, {
        updatedTurnedOff: true,
        updatedEndDate: new moment(),
      });
    case UPDATE_WARNING_PERCENTAGE:
      return Object.assign({}, state, {
        updatedWarningPercentage: action.value,
      });
    case UPDATE_NAME:
      return Object.assign({}, state, {
        updatedName: action.name,
      });
    case UPDATE_DEPTH_VISIBILITY:
      return Object.assign({}, state, {
        updatedDepthVisibility: { ...state.updatedDepthVisibility, [action.depth]: action.value },
      });
    case UPDATE_SOIL_TYPE:
      return Object.assign({}, state, {
        updatedSoilType: {
          value: action.value,
          capacity: action.capacity,
        },
      });
    case UPDATE_LATITUDE:
      return Object.assign({}, state, {
        updatedLatitude: action.latitude,
      });
    case UPDATE_LONGITUDE:
      return Object.assign({}, state, {
        updatedLongitude: action.longitude,
      });
    case UPDATE_FIELD_CAPACITY:
      return Object.assign({}, state, {
        updatedFieldCapacity: {
          ...state.updatedFieldCapacity,
          [action.depth]: action.fieldCapacity,
        },
      });
    case UPDATE_REFILL_POINT:
      return Object.assign({}, state, {
        updatedRefillPoint: { ...state.updatedRefillPoint, [action.depth]: action.refillPoint },
      });
    case UPDATE_SCALE:
      return Object.assign({}, state, {
        updatedScale: { ...state.updatedScale, [action.depth]: action.capacity },
      });
    default:
      return state;
  }
}

export function sensor(
  state = {
    isFetching: true,
    loadError: false,
    sensor: null,
    domain: false,
    advice: true,
    lastDataPoint: false,
    saving: false,
    isSaving: false,
    saveError: false,
  },
  action
) {
  switch (action.type) {
    case SAVE_SENSOR:
      return Object.assign({}, state, {
        saveError: false,
        isSaving: true,
      });
    case SAVE_SENSOR_COMPLETE:
      return Object.assign({}, state, {
        isSaving: "done",
      });
    case SAVE_SENSOR_FAILED:
      return Object.assign({}, state, {
        isSaving: false,
        saveError: true,
      });
    case REQUEST_SENSOR:
      return Object.assign({}, state, {
        loadError: false,
        isFetching: true,
      });
    case RECEIVE_SENSOR:
      return Object.assign({}, state, {
        isFetching: false,
        sensor: action.sensor,
        domainDays: action.domainDays,
        advice: action.advice,
      });
    case FAILED_SENSOR:
      return Object.assign({}, state, {
        isFetching: false,
        loadError: true,
      });
    case BRUSH_DOMAIN:
      return Object.assign({}, state, {
        domain: action.domain,
      });
    default:
      return state;
  }
}

export function sensorAnalysis(
  state = {
    hoverDate: false,
    hovered: false,
    pinned: false,
    pinDate: false,
    showAllDepths: false,
  },
  action
) {
  switch (action.type) {
    case TOGGLE_VISIBLE_DEPTHS:
      return Object.assign({}, state, {
        showAllDepths: !state.showAllDepths,
      });
    case HOVER_CHART:
      return Object.assign({}, state, {
        hovered: action.hovered,
      });
    case HOVER_DATE:
      return Object.assign({}, state, {
        hoverDate: action.hoverDate,
      });
    case TOGGLE_PIN:
      return Object.assign({}, state, {
        pinned: !state.pinned,
        pinDate: state.hoverDate,
      });
    default:
      return state;
  }
}
